<template>
  <InputComponent
    class="project-page-settings"
    v-if="hasThemeSetting()"
    :label="isSlot ? '' : $t('siteSettings')"
    data-field="site-settings"
  >
    <template #default>
      <div class="elder-input__element">
        <CheckboxComponent
          v-if="hasThemeSetting('hideNoOpenhouse')"
          :value="!value.hideNoOpenhouse"
          @input="$ev => (value.hideNoOpenhouse = !$ev)"
          :label="$t('showOpenhouseOnRequestIfNone')"
          theme="toggle"
        />

        <CheckboxComponent
          v-if="hasThemeSetting('hideLeadUpsell')"
          :value="!value.hideLeadUpsell"
          @input="$ev => (value.hideLeadUpsell = !$ev)"
          :label="$t('showLeadUpsell')"
          theme="toggle"
          class="mt-1"
        />

        <CheckboxComponent
          v-if="hasThemeSetting('showSoldResidentials')"
          :value="value.showSoldResidentials"
          @input="$ev => (value.showSoldResidentials = $ev)"
          :label="$t('showSoldResidentials')"
          theme="toggle"
          class="mt-1"
        />
        <CheckboxComponent
          v-if="hasThemeSetting('markReservedUnitsAsSold')"
          :value="value.markReservedUnitsAsSold"
          @input="$ev => (value.markReservedUnitsAsSold = $ev)"
          :label="$t('markReservedUnitsAsSold')"
          theme="toggle"
          class="mt-1"
        />
        <CheckboxComponent
          v-if="hasThemeSetting('hideShop')"
          :value="!value.hideShop"
          @input="$ev => (value.hideShop = !$ev)"
          :label="$t('showShopOnResidentialPage')"
          theme="toggle"
          class="mt-1"
        />

        <CheckboxComponent
          v-if="hasThemeSetting('showCompanyInLead')"
          :value="value.showCompanyInLead"
          @input="$ev => (value.showCompanyInLead = $ev)"
          :label="$t('showCompanyInfoInLead')"
          theme="toggle"
          class="mt-1"
        />
        <InputComponent
          v-if="hasThemeSetting('brochureDownloadStrategy')"
          :label="$t('brochureDownloadStrategyLabel')"
          class="mt-2"
        >
          <Select v-model="value.brochureDownloadStrategy">
            <option v-for="s in brochureDownloadStrategies" :key="s.value" :value="s.value">{{ s.label }}</option>
          </Select>
        </InputComponent>
      </div>
    </template>
  </InputComponent>
</template>

<script>
import { mapState } from 'vuex'
import { Capitalize } from '@/utils'

import { InputComponent } from 'vue-elder-input'
import { CheckboxComponent } from 'vue-elder-checkbox'
import Select from '@/components/Select/Select'

export default {
  props: {
    data: Object,
    value: Object,
    isSlot: Boolean,
  },
  computed: {
    ...mapState({
      themes(state) {
        return (state.enums.Themes || []).filter(({ type }) => type === 'project')
      },
    }),
    ...mapState('Project', ['item']),
    ...mapState(['enums']),

    currentTheme() {
      return this.themes.find(t => t.value === this.data.theme)
    },
    brochureDownloadStrategies() {
      return this.enums.DownloadStrategies.map(value => ({
        value,
        label: this.$t('brochureDownloadStrategy' + Capitalize(value)),
      }))
    },
  },
  methods: {
    hasThemeSetting(setting) {
      if (!this.currentTheme) return false
      let settings = this.currentTheme.siteSettings
      if (!setting) return settings.length > 0

      return settings.includes(setting)
    },
  },
  components: {
    InputComponent,
    CheckboxComponent,
    Select,
  },
}
</script>

<style lang="scss">
.project-page-settings {
  grid-column-end: span 2;
}
</style>
